<template>
  <div>
    <h3>{{channel.Name}} ({{channel.Number}})</h3>
    <table class="table table-striped">
      <caption>{{showDate | moment("dddd D MMMM YYYY")}}</caption>
      <tbody>
        <tr v-for="show in shows" :key="show.Key" tabindex="0">
          <td>{{show.DateStartStr}} - {{show.DateEndStr}}</td>
          <td>
            <p>
              <em>{{show.Title}}</em>
            </p>
            <p>{{show.Description}}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
caption {
  caption-side: top;
}
</style>

<script>
import API from "../apis/firstmedia.js";
import moment from "moment";

export default {
  props: {
    channelCode: {
      type: Number,
      required: true
    },
    showDate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fromServer: {}
    };
  },
  computed: {
    channel: function() {
      if (!this.fromServer.Channels || this.fromServer.Channels.length == 0) {
        return { Name: "", Number: 0 };
      }
      return this.fromServer.Channels[0];
    },
    shows: function() {
      if (!this.fromServer.Schedules) {
        return [];
      }
      let transformed = this.fromServer.Schedules.map(s => ({
        Key: s.DateStart + s.Title,
        DateStart: s.DateStart,
        DateStartStr: moment
          .utc(s.DateStart)
          .local()
          .format("ddd HH:mm"),
        DateEnd: s.DateEnd,
        DateEndStr: moment
          .utc(s.DateEnd)
          .local()
          .format("HH:mm"),
        Title: s.Title,
        Description: s.Description
      }));
      return transformed;
    }
  },
  filters: {
    moment: function(date, format) {
      return moment(date).format(format);
    }
  },
  async created() {
    await this.loadData();
  },
  watch: {
    channelCode: "loadData",
    showDate: "loadData"
  },
  methods: {
    async loadData() {
      let channelCodes = [Number(this.channelCode)];
      let startDate = moment(this.showDate).toISOString();
      let endDate = moment(startDate)
        .add(1, "days")
        .toISOString();
      let token = await this.$store.dispatch("spinner/needSpinner");
      this.fromServer = await API.getSchedule(channelCodes, startDate, endDate);
      this.$store.dispatch("spinner/dontNeedSpinner", token);
    }
  }
};
</script>